import { ColorPalette } from "@/components/color-palette/ColorPalette";

import type { DocumentModel } from "@/models/DocumentModel";
import type { Color } from "@corca/data";

type Props = {
  doc: DocumentModel;
};

export function BlockColorPalette({ doc }: Props) {
  const { tiptap, editorState } = doc.editor;

  if (!tiptap) {
    return null;
  }

  const handleColorChange = (color: Color) => {
    tiptap.chain().setBackgroundColor(color).focus().run();
  };

  return (
    <ColorPalette
      currentColor={editorState.blockBackgroundColor}
      onSelect={handleColorChange}
      type="background"
    />
  );
}
